import { invariant } from '@streem/toolbox';
export function buildDateFromTimeParts({ hours, minutes, seconds }, today) {
    const date = new Date(today);
    date.setUTCHours(hours);
    date.setUTCMinutes(minutes);
    date.setUTCSeconds(seconds);
    date.setUTCMilliseconds(0);
    return date;
}
export function parseTimeString(time) {
    const [hours, minutes, seconds] = time.split(':');
    return {
        hours: Number.parseInt(hours),
        minutes: Number.parseInt(minutes),
        seconds: Number.parseInt(seconds),
    };
}
export function checkIfCurrentDateBetweenStartAndEndTime(startTimeUtc, endTimeUtc, today) {
    const startTimeParts = parseTimeString(startTimeUtc);
    const endTimeParts = parseTimeString(endTimeUtc);
    const startTime = buildDateFromTimeParts(startTimeParts, today);
    const endTime = buildDateFromTimeParts(endTimeParts, today);
    const startAfterEnd = startTime > endTime;
    if (startAfterEnd) {
        // if the start time is after the end time, then return true when current time
        //    is not between start and endTime.  Ex: startTime = 13:00:00 UTC (6am CST),
        //    endTime = 02:00:00 UTC (7pm CST).  In this case, experts do not work
        //    between 7pm (02:00:00 UTC) and 6am (13:00:00), so we check to see if the
        //    current time is outside of that range.
        return !(startTime >= today && endTime <= today);
    }
    // if the start time is before the end time, return true when current time between
    //    start and end time
    return endTime >= today && startTime <= today;
}
export function checkIfCurrentTimeInHoursOfOperation(workingHoursByDay, today) {
    // if no working hours set, return true
    if (!Array.isArray(workingHoursByDay) || workingHoursByDay.length === 0) {
        return true;
    }
    const dayOfWeek = today.getUTCDay();
    // see if there are working hours set up for the current day.  If not, return false
    const maybeWorkingHours = workingHoursByDay.find(wh => {
        return wh.id === dayOfWeek.toString() && !wh.isHoliday;
    });
    if (maybeWorkingHours == null) {
        return false;
    }
    invariant(maybeWorkingHours.startTimeUtc && maybeWorkingHours.endTimeUtc, `unexpected condition: startTime or endTime were missing: ${JSON.stringify(maybeWorkingHours)}`);
    return checkIfCurrentDateBetweenStartAndEndTime(maybeWorkingHours.startTimeUtc, // trust that these are formatted properly
    maybeWorkingHours.endTimeUtc, today);
}
export function findWorkingHoursForGroup(groupName, tradeAreas) {
    if (tradeAreas == null) {
        return undefined;
    }
    const maybeArea = tradeAreas.find(ta => ta.id === groupName);
    return maybeArea?.videoConferenceSettings?.workingHoursByDay;
}
//# sourceMappingURL=call_transfer_utils.js.map